/* eslint-disable no-magic-numbers */
import { Component, Input, OnInit } from "@angular/core";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarEmpty } from "@fortawesome/free-regular-svg-icons";

const EMPTY_RATE = 0;
const RATING_MAX = 5;

@Component({
    selector: "app-product-ratings",
    templateUrl: "./product-ratings.component.html",
    styleUrls: ["./product-ratings.component.scss"],
    standalone: true,
    imports: [FontAwesomeModule]
})
export class ProductRatingsComponent implements OnInit {
  @Input() productRating!: number;
  filledRate!: number;
  filledStarsArray: number[] = [];
  emptyRate = RATING_MAX;
  emptyStarsArray: number[] = [];
  hasHalfStar!: boolean;
  
  // FontAwesome icons
  faStar = faStar;
  faStarHalf = faStarHalfAlt;
  faStarEmpty = faStarEmpty;

  ngOnInit(): void {
    this.filledRate = Math.floor(this.productRating);
    this.hasHalfStar = this.productRating % this.filledRate > EMPTY_RATE;
    this.emptyRate = RATING_MAX - Math.ceil(this.productRating);

  }

  get filledStars(): number[] {
    this.filledStarsArray = [];

    for (let index = 0; index < this.filledRate; index++) {
      this.filledStarsArray.push(1);
    }

    return this.filledStarsArray;
  }

  get emptyStars(): number[] {
    this.emptyStarsArray = [];
    for (let index = 0; index < this.emptyRate; index++) {
      this.emptyStarsArray.push(1);
    }

    return this.emptyStarsArray.fill(this.emptyRate);
  }
}
